import { fork, put, call, select, all } from 'redux-saga/effects';
import { selectAuthToken } from 'containers/App/selectors';
import { setModal } from "containers/RootModal/actions";
import { LAPSED_MODAL } from "./containers/RootModal/constants";

export function* apiSaga(fn, args, successAction, failureActions) {
  try {
    const response = yield call(fn, ...args);
    yield put(successAction(response));
  } catch(error){
    // Handle both single action and array of actions
    const actions = Array.isArray(failureActions) ? failureActions : [failureActions];

    if (actions.length > 1) {
      yield all(actions.map(failureAction => put(failureAction(error))));
    } else {
      if (error.message === 'Lapsed') {
        yield put(setModal({ modalType: LAPSED_MODAL }));
      } else {
        yield put(actions[0](error));
      }
    }
  }
}

export function* authedApiSaga(fn, args, successAction, failureAction) {
  const token = yield select(selectAuthToken());
  yield* apiSaga(fn, [token, ...args], successAction, failureAction);
}

// Collect Sagas and fork from containers
import appSaga from 'containers/App/sagas';
import signInSaga from 'containers/SignInPage/sagas';
import forgotPasswordSaga from 'containers/ForgotPasswordPage/sagas';
import channelsSaga from 'containers/ChannelsPage/sagas';
import accountSaga from 'containers/AccountPage/sagas';
import leadSaga from 'containers/LeadsPage/sagas';
import accountVerificationSaga from 'containers/ConfirmEmailPage/sagas';
import galerySaga from 'containers/GalleryPage/sagas';
export default function* root() {
  yield all([
    fork(appSaga),
    fork(signInSaga),
    fork(channelsSaga),
    fork(forgotPasswordSaga),
    fork(accountSaga),
    fork(leadSaga),
    fork(accountVerificationSaga),
    fork(galerySaga),
  ]);
}
